var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg017IconCebRequestChanges(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.037.072h5.45v4.944H.037z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3.097 30.434c-.108-.107-.431.009-.761.111-.316.095-.637.18-.78.043-.278-.263.314-1.035.255-1.284a.096.096 0 0 0-.02-.04c-.09-.108-.392.012-.666.092L0 32.073l3.067-1.27c.068-.158.101-.297.03-.37"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8813C",
    d: "M8.497 28.331c-.168-.167.197-.752.442-1.302.156-.352.262-.689.148-.893l-6.751 4.41c.33-.103.653-.219.76-.112.072.072.04.211-.03.368L9.22 28.26c-.347.12-.629.166-.722.072"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F39150",
    d: "M9.036 26.068a.24.24 0 0 0-.06-.044l-.022-.012c-.203-.101-.565-.04-.976.057-.757.178-1.679.477-2.074.1-.428-.41.004-1.283.235-1.94.115-.326.18-.601.063-.736a.322.322 0 0 0-.214-.102 1.008 1.008 0 0 0-.235.001l-.086.011-3.856 5.9c.06.25-.533 1.022-.256 1.285.144.136.465.052.78-.043l6.752-4.409a.341.341 0 0 0-.051-.068"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5A26D",
    d: "M1.826 29.282v-.001l3.841-5.878a3.738 3.738 0 0 0-.295.06c-.563.129-1.227.351-1.478.065-.146-.167-.112-.52.004-.88l-2.773 6.708c.274-.08.575-.2.666-.091.01.01.016.025.02.039l.015-.022z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCF5E",
    d: "M20.231 6.04L4.091 22.18l-.193.467c-.116.36-.15.714-.004.881.251.286.915.064 1.478-.066.103-.025.202-.044.295-.059L21.63 7.441l-1.399-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBE23",
    d: "M21.63 7.44L5.667 23.404l.086-.01c.087-.01.166-.012.235-.002a.322.322 0 0 1 .214.102c.117.135.052.41-.063.737-.231.656-.663 1.529-.235 1.938.395.378 1.317.079 2.074-.1.411-.096.773-.157.976-.056l.021.012a.242.242 0 0 1 .06.044c.021.02.037.044.052.068l15.619-15.62-3.076-3.075z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3A922",
    d: "M24.706 10.516l-15.62 15.62c.115.204.01.541-.147.893-.245.55-.61 1.135-.442 1.302.093.094.375.047.722-.072l.673-.277 16.14-16.14-1.326-1.326z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.618)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F08281",
    d: "M3.58.072L.038 3.617l1.398 1.4L5.487.965A9.408 9.408 0 0 0 3.58.072",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DE4B49",
    d: "M32 5.873a9.31 9.31 0 0 0-.838-1.813L27.13 8.093l1.325 1.326L32 5.873"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E95F5E",
    d: "M29.782 2.29v-.001A9.177 9.177 0 0 0 28.104.966l-4.051 4.05 3.076 3.077 4.032-4.033a9.136 9.136 0 0 0-1.38-1.77"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M28.455 9.419L27.13 8.093l-2.424 2.423 1.325 1.326z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M22.655 3.618L20.23 6.04l1.4 1.4 2.423-2.424z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M24.054 5.017L21.63 7.44l3.076 3.075 2.424-2.423z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg017IconCebRequestChanges);
export default __webpack_public_path__ + "static/media/017-icon-ceb-request-changes.3aeca78fd863c90b05aac3e6e185882c.svg";
export { ForwardRef as ReactComponent };